export const UPDATE = "UPDATE_INVENTORY";